export const equipmentTypeNamesList = {
  gateways: 'Gateways',
  routers: 'Repeaters',
  motes: 'Sensor Motes',
  nodes: 'Nodes',
  installationPoints: 'Tethered Sensors',
  tachometers: 'Tachometers',
};
